import React from 'react'
import img1 from '../../assets/coursecard/1.jpg'
import img2 from '../../assets/coursecard/2.jpg'
import img3 from '../../assets/coursecard/3.jpg'
import img4 from '../../assets/coursecard/4.jpg'
import img5 from '../../assets/coursecard/5.jpg'
import img6 from '../../assets/coursecard/6.jpg'
import img9 from '../../assets/coursecard/9.jpg'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const Courseonline = () => {
  return (
    <div className='course-sec'>
        <div class="row align-items-center">
                            <div class="col-lg-4 mb-5">
                                <a href=' /product/physical-design-online/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img1} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                            <div class="card-box-rating">Discover, Learn, Grow</div>
                                            <div class="card-content-title mb-3">Physical Design Online</div>
                                            <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                            <div class="card-box-duration d-flex justify-content-between">
                                                <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                                                <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href=' /product/design-for-test-dft-online/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img2} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">Design For Test Online</div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                          </div>
                                    </div>
                                    </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href=' /product/asic-verification-online/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img3} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">ASIC Verification Online
                                                        </div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                                    </div>
                                    </div>
                                    </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href=' /product/analog-layout-design-online/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img4} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">Analog Layout Design Online
                                                        </div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                                    </div>
                                    </div>
                                    </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href=' /product/rtl-coding-fpga-design/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img5} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">RTL Coding and FPGA Design Online
                                                        </div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                                    </div>
                                    </div>
                                    </a>
                            </div>
                            <div class="col-lg-4 mb-5">
                                <a href=' /product/analog-circuit-design-online/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img6} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                                        <div class="card-box-rating">Discover, Learn, Grow</div>
                                                        <div class="card-content-title mb-3">Analog Circuit Design
                                                        </div>
                                                        <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                                        <div class="card-box-duration d-flex justify-content-between">
                                                            <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>16 Weeks | View Now</span> </div>
                                                            <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                                        </div>
                                                    </div>
                                    </div>
                                    </a>
                            </div>
                            
                            <div class="col-lg-4 mb-5">
                                <a href=' /product/uvm-training-online/'>
                                    <div class="course-card-box">
                                        <div class="card-box-thumbnail">
                                            <img src={img9} alt=''/>
                                        </div>
                                        <div class="card-box-bottom">
                                            <div class="card-box-rating">Discover, Learn, Grow</div>
                                            <div class="card-content-title mb-3">UVM Training</div>
                                            <div className='mb-2'><b>Start Date:</b> Call/Whatsapp +91-97429 72744 for details</div>
                                            <div class="card-box-duration d-flex justify-content-between">
                                                <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                                                <div><button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button></div>
                                            </div>
                                        </div>
                                    </div>
                                   </a> 
                            </div>
                                        

         </div>
    </div>
  )
}

export default Courseonline